import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, NEVER } from 'rxjs';
import { InactivityService } from '../services/inactivity.service';

@Injectable()
export class ActivityInterceptor implements HttpInterceptor {

  constructor(private inactivityService: InactivityService) { }
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const inactive = this.inactivityService.checkForInactivityTimeout();
    if (inactive) {
      return NEVER;
    }

    this.inactivityService.activityNow();

    return next.handle(req);
  }
}
